export { FileUploadModal } from './FileUploadModal'

export const ACCEPT_FILE_TYPES = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
} as const
